import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import {
  catchError,
  filter,
  map,
  merge,
  of,
  first as rxFirst,
  switchMap,
  tap,
} from 'rxjs';

import { AuthApiActions } from '@lockton-apps/shared/action/auth';
import {
  AuthActions,
  AuthSelectors,
} from '@lockton-apps/shared/data-access/auth';
import { ConfigResolverService } from '@lockton-apps/shared/ui/portal-config';

import { PortalConfigService } from '../services/portal-config.service';
import * as PortalConfigActions from './portal-config.actions';
import { selectPortalConfigDefinition } from './portal-config.selectors';

@Injectable()
export class PortalConfigEffects {
  private actions$ = inject(Actions);

  loadPortalConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        AuthApiActions.loginSuccess,
        AuthActions.initSuccess,
        AuthApiActions.signUpSuccess
      ),
      switchMap(({ session }) => {
        return this.portalConfigService.getConfig(session.language).pipe(
          concatLatestFrom(() =>
            this.store.select(AuthSelectors.getRole).pipe(filter(Boolean))
          ),
          map(([config, role]) =>
            PortalConfigActions.loadPortalConfigSuccess({
              portalConfig: config,
              role,
            })
          ),
          catchError((error) =>
            of(PortalConfigActions.loadPortalConfigFailure(error))
          )
        );
      })
    )
  );

  initialiseConfigResolver$ = createEffect(
    () =>
      merge(
        this.actions$.pipe(ofType(PortalConfigActions.loadPortalConfigSuccess)),
        this.actions$.pipe(ofType(ROUTER_NAVIGATED)).pipe(rxFirst())
      ).pipe(
        concatLatestFrom(() => this.store.select(selectPortalConfigDefinition)),
        tap(([, portalConfig]) => {
          if (portalConfig) {
            this.configResolver.initialiseConfig(portalConfig);
          }
        })
      ),

    { dispatch: false }
  );

  // showPortalSelectionDialog$ = createEffect(() =>
  //   this.actions$
  //     .pipe(
  //       ofType(PortalConfigActions.loadPortalConfigSuccess),
  //       concatLatestFrom(() => this.store.select(selectUserConfigIds)),
  //       filter(
  //         ([, userConfigIds]) => !!userConfigIds && userConfigIds.length > 1
  //       )
  //     )
  //     .pipe(
  //       map(([, userConfigIds]) => userConfigIds),
  //       switchMap((userConfigIds) => {
  //         return this.dialog
  //           .open(PortalSelectionDialogComponent, {
  //             data: { userConfigIds },
  //             disableClose: true,
  //           })
  //           .beforeClosed()
  //           .pipe(
  //             map((x) => PortalConfigActions.portalSelected({ portalId: x }))
  //           );
  //       })
  //     )
  // );

  constructor(
    private readonly store: Store,
    private readonly portalConfigService: PortalConfigService,
    private readonly configResolver: ConfigResolverService,
    private readonly dialog: MatDialog
  ) {}
}
